<template>
  <IconLucideUser />
</template>
